import { makeStyles } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';

export const muiStyles = makeStyles((theme: typeof muiTheme) => ({
    detailSection: {
        width: '32%',
        minWidth: 'fit-content' as 'fit-content'
    },
    '@media (max-width: 1360px)': {
        detailSection: {
            width: '100%',
            margin: '0 55px 10px 27px'
        }
    },
    detailSectionHighlighted: { backgroundColor: theme?.app?.applicationColors.enumColors.offWhite || '#F3F3F3' },
    firmDetails: {
        minHeight: '40px',
        marginTop: '.25rem',
        padding: '.5rem .3rem',
        backgroundColor: theme?.app?.clientTheme.colors.highlightColor3 || '#B9D9EC'
    },
    firmAttribute: {
        fontSize: '1rem',
        fontWeight: 'bold' as 'bold',
        color: theme?.app?.applicationColors.enumColors.greyDark || '#333333'
    },
    cancelIcon: {
        position: 'absolute' as 'absolute',
        top: 18,
        right: 18
    },
    paperWidthXl: { width: '80%' },
    attribute: {
        fontSize: '.75rem',
        color: theme?.app?.applicationColors.enumColors.grey || '#888888',
        wordBreak: 'break-all' as 'break-all'
    }
}));